import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";

import basketImage from "../../assets/images/11697-removebg-preview.png";
import logo from "../../assets/images/raw-meat-with-spices-removebg-preview.png";
import image1 from "../../assets/images/8b203453ace0384d886b221d62df356b5ba0bb50_1614169370-removebg-preview.png";
import image2 from "../../assets/images/a6f6420093c8ca5b07705585c6ac4a493f84f1b3_1649485751.png";

import { connection } from "../../utils/apiConnection.ts";
import SpecialBasketItems from "./SpecialBasketItems.tsx";
import SpecialBasketModal from "./SpecialBasketModal.jsx";
import EditSpecialBasketModal from "./EditSpecialBasketModal.jsx";

import "./special-basket.scss";
import { useParams } from "react-router-dom";

export default function SpecalBaskets({ typeBasket }) {
  let supplierId = useParams();
  const [specialBasket, setSpecialBasket] = useState([]);

  const [selectedBasket, setSelectedBasket] = useState({});

  const [updater, setUpdater] = useState(false);

  useEffect(() => {
    let temp = {};
    typeBasket == "supplier"
      ? (temp = { supplier_id: supplierId.supplier_id })
      : (temp = {});
    connection("supplier/get_basket_with_items", temp).then((data) => {
      setSpecialBasket(data.data.reverse());
      // console.log("data s b : ", specialBasket);
    });
    // typeBasket == "supplier"
    //   ? connection("supplier/get_basket_with_items", {
    //       supplier_id: supplierId.supplier_id,
    //     }).then((data) => {
    //       setSpecialBasket(data.data.reverse());
    //       // console.log("data s b : ", specialBasket);
    //     })
    //   : connection("supplier/get_basket_with_items").then((data) => {
    //       setSpecialBasket(data.data.reverse());
    //       // console.log("data s b : ", specialBasket);
    //     });
  }, [updater]);

  return (
    <div>
      {specialBasket != "" && (
        <div className="special-basket-section">
          {/* <div className="w-100">
        <h5
          style={{ fontSize: "30px", marginRight: "30px", paddingTop: "100px" }}
        >
          {" "}
          سبدهای ویژه
        </h5>
      </div> */}
          <Swiper
            className="mySwiper"
            // dir="rtl"
            modules={[Navigation, Pagination]}
            navigation={true}
            spaceBetween={15}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              1200: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
              1050: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
              900: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
              750: {
                slidesPerView: 3.5,
                spaceBetween: 20,
              },
              650: {
                slidesPerView: 3,
                spaceBetween: 5,
              },
              550: {
                slidesPerView: 2.5,
                spaceBetween: 5,
              },
              400: {
                slidesPerView: 1,
                spaceBetween: 5,
              },
            }}
            // breakpoints={{
            //   640: {
            //     slidesPerView: 2
            //   },
            //   768: {
            //     slidesPerView: 4
            //   },
            //   1024: {
            //     slidesPerView: 5
            //   }
            // }}
          >
            <SwiperSlide className="image-at-first">
              <div className="basket-image">
                <img src={basketImage} alt="" />
                <h5
                  style={{
                    fontSize: "30px",
                    marginRight: "180px",
                    paddingTop: "40px",
                  }}
                >
                  {" "}
                  سبد های ویژه
                </h5>
              </div>
            </SwiperSlide>
            {/* {data.map((value, index) => ( */}

            {specialBasket != "" &&
              specialBasket.map((value, index) => (
                <SwiperSlide
                  key={`special-basket${index}`}
                  data-bs-toggle="modal"
                  data-bs-target="#sabadModal"
                  onClick={() => {
                    setSelectedBasket(value);
                    console.log("basket selected!!! : ", selectedBasket);
                  }}
                >
                  <SpecialBasketItems data={value} />
                </SwiperSlide>
              ))}
          </Swiper>
          <SpecialBasketModal
            selectedBasket={selectedBasket}
            setUpdater={setUpdater}
            updater={updater}
          />
          <EditSpecialBasketModal
            selectedBasket={selectedBasket}
            updater={updater}
            setUpdater={setUpdater}
          />
        </div>
      )}
    </div>
  );
}
